import { connect } from 'react-redux'
import { getItems, createPostorderWithItems, updateItem } from 'actions/campaign_postorders/create_postorder_form'

export default connect((state) => ({
  campaignId: state.campaign_postorders?.campaignId,
  locationId: state.campaign_postorders?.locationId,
  locations: state.campaign_postorders?.locations,
  items: state.campaign_postorders?.items
}), { getItems, updateItem, createPostorderWithItems })
